import moment from 'dayjs';
import numeral from 'numeral';
export function validRegExp(val, reg) {
	return reg.test(val);
}
export function getDateList(length = 0, format = 'YYYY-MM-DD') {
	let [list, i] = [[], 0];
	while (i < length) {
		let date = moment().subtract(i, 'd').format(format);
		list.push({
			label: date,
			value: date,
		});
		i++;
	}
	return list;
}
/**
 * @author David
 * 获取接口返回的data的数据。(判断层级)
 * @returns {Array} list
 */
export function getArrList(objData) {
	if (!objData) throw new Error('A parameter must be passed in');
	let istype = Object.prototype.toString;
	let [arr, list] = ['[object Object]', '[object Array]', []];
	if (istype.call(objData) === arr) return objData;
	Object.keys(objData).forEach(item => {
		if (Object.is(item, 'data')) {
			list = istype.call(objData[item]) === arr ? objData[item] : getArrList(objData[item]);
		}
	});
	return list;
}

// 今天
export function getTodayDate(format = 'YYYY-MM-DD') {
	return moment().format(format);
}

/**
 * @author David
 * 昨天  近7天  近1月  近3月 .......
 */
export function getDateRegion(key, format = 'YYYY-MM-DD', join = '至') {
	let subDay = (num, dateType) => {
		return moment().subtract(num, dateType).format(format);
	};
	let subFixedEndofDay = (num, dateType = 'day') => {
		return [subDay(num, dateType), subDay(1, dateType)].join(join);
	};

	let subStartofAddDay = (num, dateType) => {
		return moment().subtract(num, dateType).startOf(dateType).add(1, 'day').format(format);
	};
	let subEndofAddDay = (num, dateType) => {
		return moment().subtract(num, dateType).endOf(dateType).add(1, 'day').format(format);
	};
	let subFixedEndofWeek = (num, dateType = 'week') => {
		return [subStartofAddDay(num, dateType), subEndofAddDay(1, dateType)].join(join);
	};

	let subStartofWith = (num, dateType) => {
		return moment().subtract(num, dateType).startOf(dateType).format(format);
	};
	let subEndofWith = (num, dateType) => {
		return moment().subtract(num, dateType).endOf(dateType).format(format);
	};
	let subFixedEndofMonth = (num, dateType = 'month') => {
		return [subStartofWith(num, dateType), subEndofWith(1, dateType)].join(join);
	};
	let subFixedEndofNewMonth = () => {
		return [moment().startOf('month').format(format), moment().endOf('month').format(format)].join(
			join
		);
	};

	const dateList = {
		// 昨天
		DAY: {
			formatter: () => [subDay(1, 'day'), subDay(1, 'day')].join(join),
		},
		// 近7天
		DAYS_7: {
			formatter: () => subFixedEndofDay(7),
		},
		// 近28天
		DAYS_28: {
			formatter: () => subFixedEndofDay(28),
		},
		// 近30天
		DAYS_30: {
			formatter: () => subFixedEndofDay(30),
		},
		// 上周（以上周一为节点，至周末）
		WEEK: {
			formatter: () => subFixedEndofWeek(1),
		},
		// 前六个周（以前六周的周一为节点，至周末）
		WEEK_6: {
			formatter: () => subFixedEndofWeek(6),
		},
		// 本月（以上个月1号为节点，至当月末尾）
		NEWMONTH: {
			formatter: () => subFixedEndofNewMonth(),
		},
		// 上个月（以上个月1号为节点，至当月末尾）
		MONTH: {
			formatter: () => subFixedEndofMonth(1),
		},
		// 前三个月（以近三个月的1号为节点，至当月末尾）
		MONTH_3: {
			formatter: () => subFixedEndofMonth(3),
		},
		// 前六个月（以近六个月的1号为节点，至当月末尾）
		MONTH_6: {
			formatter: () => subFixedEndofMonth(6),
		},
		// 近一年（以近12个月的1号为节点，，至当月末尾）
		YEAR: {
			formatter: () => subFixedEndofMonth(12),
		},
	};
	let dateRange = '';
	Object.keys(dateList).map(item => {
		if (item == key) {
			dateRange = dateList[item].formatter();
		}
	});
	return dateRange;
}

export function getDatePoint(format = 'YYYY-MM-DD') {
	return moment().add(1, 'month').format(format);
}
// 清除對象的key值
export function clearObjectValues(data) {
	if (Object.prototype.toString.call(data) === '[object Object]') {
		Object.keys(data).forEach(item => {
			if (Object.prototype.toString.call(data[item]) === '[object Array]') {
				data[item] = [];
			} else if (Object.prototype.toString.call(data[item]) === '[object Object]') {
				data[item] = {};
			} else {
				data[item] = '';
			}
		});
	}
	return data;
}
/**
 * url参数转为json
 * @param url
 * @returns {{}}
 */
export function urlParams2Json(url) {
	let hash;
	let myJson = {};
	let hashes = url.slice(url.indexOf('?') + 1).split('&');
	for (let i = 0; i < hashes.length; i++) {
		hash = hashes[i].split('=');
		myJson[hash[0]] = hash[1];
	}
	return myJson;
}

/**
 * 获取当前页url的参数(json格式)
 * @returns {{}}
 */
export function getUrlQuery() {
	let url = decodeURI(location.href);
	let hash;
	let myJson = {};
	let hashes = url.slice(url.indexOf('?') + 1).split('&');
	for (let i = 0; i < hashes.length; i++) {
		hash = hashes[i].split('=');
		myJson[hash[0]] = hash[1];
	}
	return myJson;
}

/**
 * json对象转url参数
 * @param json
 * @returns {string}
 * @constructor
 */
export function Json2UrlQuery(json = {}) {
	let param = '';
	param = Object.keys(json)
		.map(function (key) {
			// body...
			return encodeURIComponent(key) + '=' + encodeURIComponent(json[key]);
		})
		.join('&');
	return param;
}

export function urlReplace(url, PathParam) {
	let newUrl = url;
	const pet = new RegExp('{[^}]+}', 'g');
	let urls = url.match(pet);
	if (PathParam) {
		for (var i in PathParam) {
			for (var j = 0; j < urls.length; j++) {
				if (urls[j].slice(1, -1) === i) {
					newUrl = url.split(urls[j])[0] + PathParam[i] + url.split(urls[j])[1];
				}
			}
		}
	}
	return newUrl;
}

export const json2url = function (json) {
	var arr = [];
	Object.keys(json).forEach(function (key) {
		if (json[key] !== undefined && json[key] !== null) {
			arr.push(encodeURIComponent(key) + '=' + encodeURIComponent(json[key]));
		}
	});
	var params = arr.join('&');
	return params;
};

export function hideMobile(str) {
	return str.replace(/(\d{4})$/, '****');
}
export function Base64FileName(str) {
	let suffix = str.split('.')[str.split('.').length - 1];
	let fileName = Buffer.from(str.split(suffix)[0]).toString('base64') + '.' + suffix;
	return fileName;
}
export function formatElementPerc(num) {
	if (num === Infinity) num = 100;
	return parseInt(numeral(num).format('0,0'));
}
export function firstUpperCase(str) {
	return str.toLowerCase().replace(/( |^)[a-z]/g, L => L.toUpperCase());
}

export function isAssetTypeAnImage(ext) {
	return (
		['png', 'jpg', 'jpeg', 'bmp', 'gif', 'webp', 'psd', 'svg', 'tiff'].indexOf(
			ext.toLowerCase()
		) !== -1
	);
}
export function download({ url, fileName }) {
	fetch(url).then(res =>
		res.blob().then(blob => {
			var a = document.createElement('a');
			var url = window.URL.createObjectURL(blob);
			a.href = url;
			a.download = fileName;
			a.click();
			window.URL.revokeObjectURL(url);
		})
	);
}
export function download2(data, fileName) {
	if (!data) throw new Error('arguments is not null!');
	let blob = new Blob([data]);
	window.URL = window.URL || window.webkitURL;
	let url = window.URL.createObjectURL(blob);
	let link = document.createElement('a');
	link.style.display = 'none';
	link.href = url;
	link.setAttribute('download', fileName);
	document.body.appendChild(link);
	link.click();
	window.URL.revokeObjectURL(url);
}
// 自建站预览地址
export function getPerviewHostname() {
	let perviewHostname = 'view.tq365.cn';
	if (process.env.NODE_ENV == 'production') {
		perviewHostname = 'view.skytech.cn';
	} else if (process.env.NODE_ENV == 'testing') {
		perviewHostname = 'test.view.skytech.cn';
	} else if (process.env.NODE_ENV == 'preProduction') {
		perviewHostname = 'test.view.skytech.cn';
	}
	return perviewHostname;
}
// 自建站后台管理地址
export function getAutoBackendHostname() {
	let hostname = '192.168.1.228:8084';
	if (process.env.NODE_ENV == 'production') {
		hostname = 'admin.p.skytech.cn';
	} else if (process.env.NODE_ENV == 'testing') {
		hostname = 'test.admin.p.skytech.cn';
	} else if (process.env.NODE_ENV == 'preProduction') {
		hostname = 'test.admin.p.skytech.cn';
	}
	return hostname;
}
export function encode(str) {
	return window.btoa(encodeURIComponent(str));
}
export function decode(str) {
	return window.decodeURIComponent(atob(str));
}

/*
构造树形数据需要先找出主干，再找各枝干的枝干
@props
    level -- 用于标识数据等级的字段
    root  -- 用于标识一级数据等级的值
    example:{rank:1}
*/
export function buildTreeData(
	sourceData,
	props = { id: 'id', pid: 'parentId', level: 'rank', root: 1 }
) {
	if (!Array.isArray(sourceData) && sourceData.length == 0)
		throw new Error('sourceData is not an Array or empty length');

	let id = props.id;
	let pid = props.pid;
	let level = props.level;

	// 元素的pid等于当前对象的id
	const findByChildren = function (parentId) {
		return sourceData.filter(source => parentId === source[pid]);
	};
	let copyData = [];
	const init = () => {
		sourceData.map(item => {
			if (item[level] == props.root) {
				let model = { ...item };
				let children = findByChildren(item[id]);
				if (children.length > 0) {
					model.children = [...children];
				}
				copyData.push(model);
			}
		});
	};

	const build = function (dataArr) {
		let children = [];
		dataArr.map(data => {
			if (data.children) {
				build(data.children);
			} else {
				children = findByChildren(data[id]);
				if (children.length > 0) {
					data.children = children;
					build(data.children);
				}
			}
		});
		return copyData;
	};
	init();
	return build(copyData);
}
// 对异步请求方法统一使用trycatch的封装
export const asyncCatch = async (asyncFun, arg) => {
	try {
		const res = await asyncFun(arg);
		return res.status >= 200 && res.status < 400 ? [null, res] : [res.errMsg, null];
	} catch (err) {
		console.error(err);
		return [err, null];
	}
};
export function transformdata(_data) {
	let transformData = {};
	_.forEach(_data, (item, key) => {
		transformData[key] = item.value;
	});
	return transformData;
}

export function getWebPermission(service) {
	return async function () {
		return service();
	};
}
export function bracketMatch(str) {
	const length = str.length;
	if (length === 0) {
		return true;
	}
	const stack = []; // 借助数组模拟栈
	const leftBracket = '{'; // 定义左括号
	const rightBracket = '}'; // 定义右括号
	for (let index = 0; index < length; index++) {
		const s = str[index];
		if (leftBracket.includes(s)) {
			// 如果出现左括号，压栈
			stack.push(s);
		} else if (rightBracket.includes(s)) {
			// 如果出现右括号，需要判断栈顶元素与之是否匹配，是否需要出栈
			const top = stack[stack.length - 1]; // 栈顶元素
			// 左右括号是否匹配
			if (isMatch(top, s)) {
				stack.pop(); // 出栈，注意这儿没有压栈操作
			} else {
				return false;
			}
		}
	}
	return stack.length === 0; // 长度为 0 代表括号匹配
}
// 判断左右括号是否匹配
function isMatch(left, right) {
	if (left === '{' && right === '}') {
		return true;
	} else {
		return false;
	}
}
